// extracted by mini-css-extract-plugin
export var divider = "_1k-0";
export var dividerText = "_1k-2";
export var dividerVertical = "_1k-1";